import type { FC, PropsWithChildren } from "react";

import style from "./styles/Form.module.scss";

export interface FormSectionProps {
  title?: string;
}

const FormSection: FC<PropsWithChildren<FormSectionProps>> = (props) => {
  return (
    <div className={style.form_section}>
      {props.title && <div className={style.form_section_title}>{props.title}</div>}
      <div className={style.form_section_groups}>{props.children}</div>
    </div>
  );
};

export default FormSection;
